export default __webpack_public_path__ + "b0181e8222062cc6a64b1865bc0efd3f.svg";